import { HealthStatus, getHealthStatusDef } from '../health';

interface ScatterSeries {
  name: string;
  color: string;
  data: Record<string, unknown>[];
}

interface ElementData {
  status?: number;
  x?: number;
  y?: number;
  name?: string;
}

export const getHealthScatterSeries = (status: HealthStatus): ScatterSeries => {
  const { name, color } = getHealthStatusDef(status);
  return {
    name,
    color,
    data: [],
  };
};

export const toHealthScatterSeries = (data: ElementData[]): ScatterSeries[] => {
  // Early return for empty data
  if (!data.length) return [];

  // Initialize the scatter series for each health status
  const healthSeries = [0, 1, 2, 3].map(status => getHealthScatterSeries(status));

  // Aggregate data into corresponding scatter series
  data.forEach(({ status, x, y, name }) => {
    const statusIndex = status ?? 1;
    healthSeries[statusIndex].data.push({ x: x ?? 0, y: y ?? 0, name });
  });

  return healthSeries;
};
